import axios from 'axios';

import '../sass/success-stories.scss';

(() => {
    const $successStories = document.querySelectorAll('.success-stories');

    if (!$successStories) return;

    $successStories.forEach($successStory => {
        const $list = $successStory.querySelector('.success-stories__list');
        const $loadMoreWrap = $successStory.querySelector('.success-stories__load-more-wrap');
        const $loadMore = $successStory.querySelector('.success-stories__load-more');

        const filterController = new AbortController();
        
        const loadMore = () => {
            if (!$list) return;

            const page = $list?.dataset?.page ? parseInt($list.dataset.page) : 1;
            const postsPerPage = $list?.dataset?.postsPerPage ? parseInt($list.dataset.postsPerPage) : 2;

            const nextPage = page + 1;

            axios.get(GLOBALS.AJAX_URL, {
                params: {
                    action: 'sg_wireless_ajax_get_success_stories', 
                    posts_per_page: postsPerPage,
                    page: nextPage,
                },
                signal: filterController.signal,
            }).then(response => {
                if (response?.data?.html) {
                    $list.insertAdjacentHTML('beforeend', response.data.html);
                }

                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);

                $list.dataset.page = nextPage;

                if (!response?.data?.found_posts || postsPerPage * nextPage >= response.data.found_posts) {
                    $loadMoreWrap?.classList.add('success-stories__load-more-wrap--hide');
                }

                params.delete('success_stories_page');
                params.append('success_stories_page', nextPage);

                window.history.replaceState(null, document.title, url.pathname + (params.toString() ? '?' + params.toString() : ''));
            });
        };

        const initLoadMore = () => {
            if (!$loadMore) return;

            $loadMore.addEventListener('click', e => {
                e.preventDefault();

                loadMore();
            });
        };

        initLoadMore();
    });
})();
